import React from 'react';
import { brand, ctaLabel } from '../data/content';
import { handleScrollClick } from './CtaButton';
export function TopBar() {
  return <header className="border-b border-cream-line bg-cream" data-id="element-200" data-mp="231ltfmdyxl2h">
      <div className="mx-auto flex h-16 max-w-page items-center justify-between gap-3 px-5 md:px-8" data-id="element-201" data-mp="1y30t7mypv1e1">
        <a href="#top" className="whitespace-nowrap font-display text-[16px] font-extrabold tracking-tight text-teal md:text-[18px]" data-id="element-202" data-mp="1t5iv6rm8m6kt">
          {brand}
        </a>
        <a href="#offer" onClick={handleScrollClick} className="inline-flex h-10 items-center whitespace-nowrap rounded-lg bg-orange px-3 text-[12px] font-bold tracking-[0.02em] text-white transition-colors duration-150 ease-out hover:bg-orange-hover focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-orange md:px-4 md:text-[13px]" data-id="element-203" data-mp="2lten7j0v3ab9">
          {ctaLabel}
        </a>
      </div>
    </header>;
}